enum textSize {
    Small = 14,
    Medium = 16,
    Large = 18,
}

export default textSize;
